import { RequireAdmin, RequireAuth } from "@/components/common/ProtectedRoute";
import { AdminLayout } from "@/components/layouts/AdminLayout";
import { AppLayout } from "@/components/layouts/AppLayout";
import { PlayerLayout } from "@/components/layouts/PlayerLayout";
import { CourseDetail } from "@/pages/CourseDetail";
import { Courses } from "@/pages/Courses";
import { Dashboard } from "@/pages/Dashboard";
import { Profile } from "@/pages/Profile";
import { AdminCourseEditor } from "@/pages/admin/AdminCourseEditor";
import { AdminCourseList } from "@/pages/admin/AdminCourseList";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminDiscountDetail } from "@/pages/admin/AdminDiscountDetail";
import { AdminDiscountList } from "@/pages/admin/AdminDiscountList";
import { AdminDiscountNew } from "@/pages/admin/AdminDiscountNew";
import { AdminEnrollmentNew } from "@/pages/admin/AdminEnrollmentNew";
import { AdminModuleEditor } from "@/pages/admin/AdminModuleEditor";
import { AdminStudentDetail } from "@/pages/admin/AdminStudentDetail";
import { AdminStudentList } from "@/pages/admin/AdminStudentList";
import { Forbidden } from "@/pages/errors/Forbidden";
import { NotFound } from "@/pages/errors/NotFound";
import { CoursePlayer } from "@/pages/learn/CoursePlayer";
import { Route, Routes } from "react-router-dom";

export function App() {
	return (
		<Routes>
			{/* Auth gate — entire app requires authentication */}
			<Route element={<RequireAuth />}>
				{/* Student routes — AppLayout shell */}
				<Route element={<AppLayout />}>
					<Route path="/" element={<Dashboard />} />
					<Route path="/courses" element={<Courses />} />
					<Route path="/courses/:courseId" element={<CourseDetail />} />
					<Route path="/profile" element={<Profile />} />
				</Route>

				{/* Course player — PlayerLayout (minimal chrome) */}
				<Route path="/learn/:courseSlug" element={<PlayerLayout />}>
					<Route index element={<CoursePlayer />} />
					<Route path=":moduleSlug" element={<CoursePlayer />} />
				</Route>

				{/* Admin routes — AdminLayout shell (requires admin role) */}
				<Route element={<RequireAdmin />}>
					<Route element={<AdminLayout />}>
						<Route path="/admin" element={<AdminDashboard />} />
						<Route path="/admin/courses" element={<AdminCourseList />} />
						<Route path="/admin/courses/new" element={<AdminCourseEditor />} />
						<Route path="/admin/courses/:id" element={<AdminCourseEditor />} />
						<Route path="/admin/courses/:id/modules/:mid" element={<AdminModuleEditor />} />
						<Route path="/admin/students" element={<AdminStudentList />} />
						<Route path="/admin/students/:id" element={<AdminStudentDetail />} />
						<Route path="/admin/enrollments/new" element={<AdminEnrollmentNew />} />
						<Route path="/admin/discounts" element={<AdminDiscountList />} />
						<Route path="/admin/discounts/new" element={<AdminDiscountNew />} />
						<Route path="/admin/discounts/:id" element={<AdminDiscountDetail />} />
					</Route>
				</Route>
			</Route>

			{/* Error pages (outside auth gate) */}
			<Route path="/403" element={<Forbidden />} />
			<Route path="*" element={<NotFound />} />
		</Routes>
	);
}
